<template>
    <div class="us-search-div">
        <div v-if="args.search">
            <!-- <el-divider content-position="left">Artikel</el-divider>

            <div v-if="articles.length > 0">
                Folgende Artikel zum Thema "{{ args.search }}" wurden gefunden:
                <ul v-for="article in articles" :key="article.id">
                    <li>
                        <router-link :to="{ path: '/article/' + article.id }">{{ article.title }}</router-link>
                    </li>
                </ul>
            </div>
            <div v-else>Keine Artikel zu "{{ args.search }}" gefunden...</div>

            <div class="us-journey-divider">&nbsp;</div> -->
            <el-divider content-position="left">Reisen</el-divider>

            <div v-if="journeys.length > 0">
                Folgende Reisen wurden gefunden:
                <ul v-for="journey in journeys" :key="journey.id">
                    <li>
                        <router-link :to="{ path: '/journeydetail/' + journey.id_jrn_journey }">{{ journey.title }}</router-link>
                    </li>
                </ul>
            </div>
            <div v-else>Keine Reisen zu "{{ args.search }}" gefunden...</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            args: {},
            articles: [],
            journeys: []
        }
    },
    mounted() {
        this.args = core.getPathArgs(["search"])
        // this.getContent()
        this.getJourneys()
    },
    methods: {
        getContent() {
            content.forEach(beitrag => {
                if (beitrag.text.toLowerCase().indexOf(this.args.search.toLowerCase()) !== -1) {
                    this.articles.push(beitrag)
                }
            })
        },
        getJourneys() {
            this.loading = true
            let args = core.getPathArgs(["id"])
            core.backend("jrn.listJourneysWeb", { id_acc_account: core.id_acc_account, search: this.args.search ? this.args.search.toLowerCase() : '' }, (err, res) => {
                this.journeys = res.data.rows
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-divider__text {
    font-size: 120%;
}

.us-journey-divider {
    padding: 20px;
}

.us-search-div {
    padding: 2vw;
}
</style>